module.exports = __webpack_public_path__ + "img/lk-mode-mobile-grey.b7ac2952.svg";